import _                            from 'underscore';
import React, { useRef, useEffect } from 'react';
import { getKeyByValue }            from '../util/FunctionalUtility';

function useTabIndexToRoute( mapping: Record<string, number> ){
	
	const getRouteAsIndex = ( routeString: string ): number | null => {
		
		return mapping[ routeString ] ?? null;
	}
	
	const getIndexAsRoute = ( index: number ): string | null => {
		
		let match = getKeyByValue( mapping, index );
		
		return ( match.length > 0 ) ? match[ 0 ] : null;
	}
	
	return {
		getRouteAsIndex,
		getIndexAsRoute
	}
}

export { useTabIndexToRoute };
